(function () {
  if (window.__dscBuyNowMagicBridgeBound) return;
  window.__dscBuyNowMagicBridgeBound = true;

  function openMagicPath(root) {
    if (!root) return;

    var addToCartButton = root.querySelector('[data-add-to-cart]');
    if (addToCartButton && !addToCartButton.disabled) {
      addToCartButton.click();
      return;
    }

    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    }).then(function () {
      if (typeof window.dscOpenCart === 'function') {
        window.dscOpenCart();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-buy-now], [data-mobile-buy-now]');
    if (!trigger) return;

    if (typeof window.dscTriggerMagicCheckout === 'function') {
      return;
    }

    var root = trigger.closest('[class*="dsc-pdp--"]') || document;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openMagicPath(root);
  }, true);
}());
